import { useQuery } from 'react-query'
import { getMerchantCashAdvances } from '../api/merchant-cash-advances.api'

export function useGetMerchantCashAdvances(merchantId: string) {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ['cash-advances', merchantId],
    queryFn: () => getMerchantCashAdvances(merchantId),
  })
}
